module.exports = __webpack_public_path__ + "img/nav-bar-icon.48e49113.svg";